module.exports = __webpack_public_path__ + "static/media/Baksida.919ff85f.JPG";